<template>
  <ModalsContainer />
</template>

<script>
import { mapActions } from 'vuex'
import { ModalsContainer } from 'vue-final-modal'

export default {
  name: 'modal-config',
  components: { ModalsContainer },
  props: {
    shareLabel: String,
    shareButtonLabel: String,
    shareButtonResultText: String,
    shareEmailSubject: String
  },
  mounted() {
    this.changeShareLabel(this.shareLabel)
    this.changeShareButtonLabel(this.shareButtonLabel)
    this.changeShareButtonResultText(this.shareButtonResultText)
    this.changeShareEmailSubject(this.shareEmailSubject)
  },
  methods: {
    ...mapActions('shareConfig', [
      'changeShareLabel',
      'changeShareButtonLabel',
      'changeShareButtonResultText',
      'changeShareEmailSubject'
    ]),
  }
}
</script>
